import React from "react";
import "./footer.css";

function footer() {
  return (
    <div>
      <div className="footer">
        <h4>It was nice to have you here, see you around</h4>
        <p className="footTitle alignCenter">Parul Gupta</p>
        <p className="madewithlove">Made with ❤️ in India</p>
        <strong>Copyright ©️ 2023 | All Rights Reserved</strong>
      </div>
      <img className="footer-img" src="https://akshaysaini.in/img/foot.jpg" />
    </div>
  );
}

export default footer;
